import(/* webpackMode: "eager" */ "/app/src/app/globals.scss");
import(/* webpackMode: "eager" */ "/app/src/app/amp/extension-base.scss");
import(/* webpackMode: "eager" */ "/app/node_modules/@ginieapp/ginie-ui/css/styles.css");
import(/* webpackMode: "eager" */ "/app/src/views/ChunkErrorReload.jsx");
import(/* webpackMode: "eager" */ "/app/src/views/LayoutPlugins.jsx")